module.exports = __webpack_public_path__ + "img/323C4D_B79039_7C6A44_605C48-256px.9d9a7f9d.png";